const Commissioning = () => {
  return <h1>Commissioning</h1>;
};

export default Commissioning;
